import { CardsDiamondOutlineIcon } from './CardsDiamondOutlineIcon';

/**
 * author: Michael Richins
 * id 529FA74E-39AF-4AF4-BAD3-637FDFBD53AE
 * name cards-diamond-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-diamond-outline.svg
 * tags
 * - Transportation + Road 
 */
export const CarpoolLaneOutlineIcon = CardsDiamondOutlineIcon;
export default CarpoolLaneOutlineIcon